import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
    {
        question: "How much does mobile game development cost?",
        answer: `<p>Mobile game development is a comprehensive process involving multiple stages like concept design, character animation, visual optimization, etc. The cost of mobile game development depends primarily on the nature of your game, graphics, and advanced features. A basic 2D game development project like Tetris costs around $30,000, while an advanced 3D mobile game with fascinating characters and storyline starts from $200,000.</p>`,
    },
    {
        question: "How to hire the best mobile game development company?",
        answer: `<p>Investing in mobile game development requires substantial capital. Make sure you consider the following factors to hire the best mobile game app development company:</p>
                    <ul>
                    <li><strong>Portfolio:</strong> Check whether the mobile game development company you’re partnering with has experience building the same kind of game apps like yours.</li>
                    <li><strong>Budget:</strong> Interview 2 – 3 mobile game development companies and take pricing quotes to negotiate the game development cost with confidence.</li>
                    <li><strong>Timeline:</strong> Game development can take up to 12 – 18 months, or even more depending on the storyline and the nature of game. However, not every game requires this much time. Ask your game development company for a project roadmap and ETA before you sign the contract.</li>
</ul>`,
    },
    {
        question: "What are the top mobile game development engines in 2024?",
        answer: `<p>Mobile game development engines play a crucial role in building fascinating game apps. Below are the top mobile game development engines in 2024:</p>
            <ul>
            <li>Unity</li>
            <li>Unreal Engine</li>
            <li>CryEngine</li>
</ul>
`,
    },
    {
        question: "What types of games do you specialize in developing?",
        answer: `<p>TekRevol specializes in developing a wide range of games including multiplayer games, role-playing games (RPGs), simulation games, sports games, puzzle games, action games, adventure games & strategy games.</p>`,
    },
    {
        question: "How long does it typically take to develop a game?",
        answer: `<p>Mobile games can be made in 12 months to 18 months. Most modern PC or console games can even take three to five years to complete. However, it totally depends on the type of the game.</p>`,
    },
    {
        question: "Do you provide post-launch support and maintenance for the games you develop?",
        answer: `<p>Yes, TekRevol provides post-launch support and maintenance for the games we develop. Our commitment extends beyond the launch phase to ensure the continued success and optimal performance of your game.</p>`,
    },
    {
        question:"How can I get started with your game development services?",
        answer: `<p>To get started with our game development services at TekRevol, simply reach out to our team through the contact form on our website or give us a call.</p>`,
    }
];

function Gamefaqs(props) {
    return (
        <div className="game_faq faq_loc p-100 tekrevol_gray_bg" >
            <Container className="h-100">
                <Row className="h-100">
                    <Col
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        xxl={12}
                        className="m-auto"
                    >
                            <h2>Game Development FAQs</h2>
                    </Col>
                </Row>
                <Row className="h-100">
                    <Col
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        xxl={12}
                        className="services_faqs"
                    >
                        <FaqComponents faqs={faqs} />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gamefaqs;
